import React, { useEffect, useState } from "react";
import { EyeOutlined, PlusOutlined, DeleteOutlined, CloseOutlined, CheckOutlined, PlusSquareFilled } from '@ant-design/icons';
import { Modal, Col, Row, Table, Dropdown, Menu, Button, Form, FormInstance, Input } from 'antd';
import { AlignType } from 'rc-table/lib/interface';

import { SelecionarArquivo } from "../../../components/Documentos/SelecionarArquivo";
import { errorMessage, mostrarInfo } from "../../../utils/messages";
import { IDocumentoTipoCertificado } from "./InterfaceCertificadoras";
import { IChaves } from "../../../Interfaces/Interfaces";
import { getDocPdf } from "../../../services/apiDocumentos";
import { hasText } from "../../../utils/utilsFunctions";
import { hasPermissao, Papel } from "../../../auth/entidadeUsuario";

interface IProps {
  form: FormInstance<any>;
  documentos: IDocumentoTipoCertificado[];
  setDocumentos: React.Dispatch<React.SetStateAction<IDocumentoTipoCertificado[]>>;
  manter?: number; // 1 : Inserir / 2 : Consultar / 3 : Editar;
}

export interface ICampos {
  visible?: string[];
  default?: string[];
  defaultNumberSelect?: number[];
  required?: number[];
  disabled?: number[];
}

const { TextArea } = Input;

const TipoCertificadoDocumento = ({ form, documentos, setDocumentos, manter }: IProps) => {

  const [chave, setChave] = useState<number|undefined>();
  const [fileList, setFileList] = useState<IChaves>();

  const [exibirModalDoc, setExibirModalDoc] = useState(false);
  const [exibirDocCadastrado, setExibirDocCadastrado] = useState("none");
  const [exibirElementoAcaoAlteracao, setExibirElementoAcaoAlteracao] = useState("inline");
  const [campos, setCampos] = useState<ICampos>(); // USADO PARA VERIFICAR OS ATRIBUTOS DOS CAMPOS POR MEIO DE UM JSON.


  useEffect(() => {
    if (documentos.length === 0) {
      setExibirDocCadastrado("none")
    } else {
      setExibirDocCadastrado("inline")
    }
  }, [documentos]);

  useEffect(() => {
    if (chave) {
      setFileList(
        {
          idDocumento: chave,
        },
      );
    }
  }, [chave]);


  useEffect(() => {
    if (manter === 2) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    } else {
      setExibirElementoAcaoAlteracao("inline");
    }
  }, [manter]);


  const controleDaGrid = (botao: string) => {
    if (!hasText(form.getFieldValue("nuProcesso"))) {
      mostrarInfo("Não é possível incluir novos documentos", "Processo ainda não informado");
    } else {
      if (botao === "cancelar") {
        setExibirModalDoc(false);
        setExibirElementoAcaoAlteracao("inline");
      } else if (botao === "incluir") {
        setExibirModalDoc(false);
        setExibirElementoAcaoAlteracao("inline");
      } else {
        setExibirModalDoc(true);
        setExibirElementoAcaoAlteracao("none");
      }
    }
    if (manter === 2) { // Detalhar
      setExibirElementoAcaoAlteracao("none");
    }
  };

  const validarDoc = () => {
    if (!fileList || !fileList.idDocumento) {
      errorMessage("Selecione um arquivo para 'upload'.");
    } else {
      form
        .validateFields([
          "idCertificadoraDocumento",
          "nmDocumento",
          "arquivo",
        ])
        .then(() => {
          controleDaGrid("incluir");
          setDadosDocumento();
          // successMessage("Documento Adicionado");
        })
        .catch((error) => {
          errorMessage("Campo obrigatório não preechido ou não validado");
        });
    }
  };

  function setDadosDocumento() {
    setDocumentos([
      ...documentos,
      {
        idTpCertificadoDocumento: -1,
        nmDocumento: form?.getFieldValue("nmDocumento") ? form?.getFieldValue("nmDocumento").toUpperCase() : undefined,
        idDocumento: chave,
        documentoChave: fileList,
        statusReg: 1,
        touched: true,
      },
    ]);
    form.resetFields([
      "idCertificadoraDocumento",
      "nmDocumento",
    ]);
    setChave(undefined);
    setFileList(undefined);
  }

  const hasCampo = (campo: string) => {
    return campos?.visible ? campos?.visible?.indexOf(campo) > -1 : false
  };

  const isCampoRequired = (campo: string) => {
    if (campos?.visible !== undefined) {
      let idx = campos?.visible?.indexOf(campo)
      if (idx > - 1) {
        return campos?.required ? (campos?.required?.[idx] === 1 ? true : false) : false
      }
    } else {
      return false
    }
  };

  const isCampoDisabled = (campo: string) => {
    if (campos?.visible !== undefined) {
      let idx = campos?.visible?.indexOf(campo)
      if (idx > - 1) {
        return campos?.disabled ? (campos?.disabled?.[idx] === 1 ? true : false) : false
      }
    } else {
      return false
    }
  };

  const campoDefaultValue = (campo: string) => {
    if (campos?.visible !== undefined) {
      let idx = campos?.visible?.indexOf(campo)
      if (idx > - 1) {
        if (campos?.default && campos?.default?.[idx] && campos?.default?.[idx] !== "null") {
          if (campo === "nmDocumento") form?.setFieldsValue({ nmDocumento: campos?.default?.[idx] });
          if (campo === "nuDocumento") form?.setFieldsValue({ nuDocumento: campos?.default?.[idx] });
          if (campo === "nmOrgaoExpedidor") form?.setFieldsValue({ nmOrgaoExpedidor: campos?.default?.[idx] });
          return campos?.default?.[idx];
        }
      }
    }
    return undefined;
  };

  const columns = [
    {
      key: "1",
      title: "Nome do Documento",
      dataIndex: "",
      render: (IDoc: IDocumentoTipoCertificado) => <>{IDoc.nmDocumento}</>,
    },
    {
      // Apenas Marca ou desmarca o campo ativo. Não existe a opção de alteração de documento. Somente exclusão e inclusão de um novo.
      key: "9",
      title: "Opções",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IDoc: IDocumentoTipoCertificado) => (
        <div style={{ display: manter === 9 ? "none" : exibirElementoAcaoAlteracao }}>
          <div style={{ display: manter === 1 ? "inline" : exibirElementoAcaoAlteracao }}>
            <DeleteOutlined
              title="Excluir documento ainda não gravado na base."
              style={{ color: "red", display: (IDoc?.idTpCertificadoDocumento && IDoc?.idTpCertificadoDocumento < 0) ? "inline" : "none" }} // EXCLUSÃO DE REGISTRO SENDO INSERIDO NO PROCESSO DE ALTERAÇÃO. OU SEJA. QUE AINDA NÃO ESTÁ NA BASE
              onClick={() => {
                setDocumentos(documentos.filter((doc) => doc !== IDoc));
              }}
            />
          </div>

          <div style={{ display: (IDoc?.idTpCertificadoDocumento && IDoc?.idTpCertificadoDocumento > 0) && hasPermissao([Papel.DILIC_MASTER]) ? exibirElementoAcaoAlteracao : "none" }}>
            <>
              <PlusSquareFilled
                title="Desmarcar para exclução/inativação"
                style={{ color: "blue", display: (IDoc?.statusReg === 1 || IDoc?.statusReg === undefined) ? "none" : "inline" }}
                onClick={() => {
                  IDoc.statusReg = IDoc.statusReg === 1 ? 2 : 1;
                  IDoc.touched = true;
                  setDocumentos(pre => {
                    return pre.map(doc => {
                      if (doc.idTpCertificadoDocumento === IDoc.idTpCertificadoDocumento) {
                        return IDoc;
                      } else {
                        return doc;
                      }
                    });
                  });
                }}
              />
              <DeleteOutlined
                title="Marcar para exclução/inativação"
                style={{ color: "red", display: (IDoc?.statusReg === 1 || IDoc?.statusReg === undefined) ? "inline" : "none" }}
                onClick={() => {
                  IDoc.statusReg = (IDoc.statusReg === 1 ? 2 : 1);
                  IDoc.touched = true;
                  setDocumentos(pre => {
                    return pre.map(doc => {
                      if (doc.idTpCertificadoDocumento === IDoc.idTpCertificadoDocumento) {
                        return IDoc;
                      } else {
                        return doc;
                      }
                    });
                  });
                }}
              />
            </>

          </div>
        </div>
      ),
    },
    {
      key: "111",
      title: "Arquivo",
      dataIndex: "",
      align: 'center' as AlignType,
      render: (IDoc: IDocumentoTipoCertificado) => (
        <Button
          id="arquivo"
          shape="round"
          icon={<EyeOutlined />}
          htmlType="button"
          onClick={() => {
            getDocPdf(IDoc.idDocumento!);
          }}
        />
      ),
    },

  ];

  let jsonDropdownMenu = [
    {
      "key": "1",
      "buttonName": "Edital ou Regulamento exigido para a prova de reconhecimento",
      "campos": {
        "visible": ["nmDocumento"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["Edital ou regulamento exigido para a prova de reconhecimento"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
    {
      "key": "2",
      "buttonName": "Conteúdo Programático exigido para a prova de conhecimento",
      "campos": {
        "visible": ["nmDocumento"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["Conteúdo programático exigido para a prova de conhecimento"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
    {
      "key": "3",
      "buttonName": "Comprovação do prazo de validade máximo de quatro anos",
      "campos": {
        "visible": ["nmDocumento"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["Comprovação do prazo de validade máximo de quatro anos"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
    {
      "key": "4",
      "buttonName": "Comprovação da Manutenção de registros com informações dos profissionais certificados e certificados emitidos",
      "campos": {
        "visible": ["nmDocumento"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["Comprovação da Manutenção de registros com informações dos profissionais certificados e certificados emitidos"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
    {
      "key": "5",
      "buttonName": "Comprovação da Emissão do Certificado mediante aprovação em exames por provas ou provas e títulos",
      "campos": {
        "visible": ["nmDocumento"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["Comprovação da Emissão do Certificado mediante aprovação em exames por provas ou provas e títulos"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
    {
      "key": "6",
      "buttonName": "Apresentação dos critérios para a renovação do certificado",
      "campos": {
        "visible": ["nmDocumento"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["Apresentação dos critérios para a renovação do certificado"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
    {
      "key": "7",
      "buttonName": "Nota Técnica",
      "campos": {
        "visible": ["nmDocumento"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["Nota Técnica"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
    {
      "key": "9",
      "buttonName": "Outro",
      "campos": {
        "visible": ["nmDocumento"], // SE O NOME DO CAMPO NÃO ESTIVER NA LISTA NÃO APARECERÁ PARA PREENCHIMENTO
        "default": ["Outro"], // ESTA E AS PRÓXIMAS ARRAYS DEVEM TER O MESMO TAMANHO DA 'VISEBLE'. ESTA INDICA O VALUR DEFAULT, CASO EXISTA. 
        "defaultNumberSelect": [0], // EM CASO DO CAMPO SER UM SELECT, INDICAR TAMBÉM O INDEX. NESTE CASO, 1 É O INDEX DO BRASIL
        "required": [1], // 0 : NÃO OBRIGATÓRIO / 1 : OBRIGATÓRIO
        "disabled": [1], // 0 : HABILITADO / 1 : DESABILITADO
      }
    },
  ];

  const menuDropdown =
    (
      <Menu>
        {jsonDropdownMenu.map((e, _) => (

          <Menu.Item
            defaultChecked={false}
            key={e.key}
            id={e.key}
            style={{ textAlign: "left" }}
            onClick={() => {
              controleDaGrid(e.buttonName);
              setCampos(e.campos)
            }}
          >
            {e.buttonName}
          </Menu.Item>
          // <Divider style={{ marginTop: 0, marginBottom: 0 }}/>

        ))}
      </Menu>
    )

  return (
    <>
      <Dropdown overlay={menuDropdown} >
        <Button
          style={{ display: manter === 9 ? 'none' : exibirElementoAcaoAlteracao }}
          id="key"
          type="primary"
          shape="round"
          icon={<PlusOutlined />}
        >
          Incluir Documento
        </Button>
      </Dropdown>
      <>

        <Modal title="Documento" open={exibirModalDoc}
          style={{ top: 20 }}
          width={750}
          destroyOnHidden={true}
          onCancel={() => {
            controleDaGrid("cancelar");
            form.resetFields([
              "idCertificadoraDocumento",
              "nmDocumento",
              "arquivo",
            ]);
          }}
          closable={false}
          cancelText="Cancelar"
          cancelButtonProps={{ shape: "round", icon: <CloseOutlined /> }}

          onOk={() => {
            validarDoc();
          }}
          okText="Incluir"
          okButtonProps={{ disabled: !chave, shape: "round", icon: <CheckOutlined /> }}
        >
          <Row>
            <Col xs={24} sm={24}
              style={{ display: hasCampo("nmDocumento") ? 'inline' : 'none' }}
            >
              <Form.Item label="Nome Documento"
                labelCol={{ span: 24 }}
                name="nmDocumento"
                colon={false}
                rules={[
                  {
                    required: isCampoRequired("nmDocumento"),
                    message: "Campo Nome do Documento obrigatório não preenchido",
                  },
                ]}
              >
                <TextArea rows={2} disabled={isCampoDisabled("nmDocumento")} placeholder="Digitar Nome" defaultValue={campoDefaultValue("nmDocumento")} />
              </Form.Item>
            </Col>

          </Row>

          <Row justify="space-between">
            <Col xs={24} md={12} xl={5}>
              <SelecionarArquivo
                setChave={setChave}
                identificador={true}
              />
            </Col>
          </Row>

        </Modal>

      </>

      <Row style={{ display: exibirDocCadastrado }}>
        <Col
          xs={24}
          sm={24}
        >
          <Table
            size="small" columns={columns} dataSource={documentos} pagination={false} />
        </Col>
      </Row>
    </>
  )
};

export default TipoCertificadoDocumento;